import { render } from "./ConsumerContact.vue?vue&type=template&id=f5c0b2d2"
import script from "./ConsumerContact.vue?vue&type=script&lang=js"
export * from "./ConsumerContact.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__